<template>
  <div class="banner-title">
    <!-- <h1>{{ areaTitle }}医学影像共享平台</h1>
    <h3>{{ areaTitleEn }} Medical Image Sharing Platform</h3>-->
    <h1 :class="isPlatform && 'hengfeng'"></h1>
  </div>
</template>

<script>

export default {
  props: {
    areaTitle: String,
    areaTitleEn: String,
    isPlatform: Boolean
  },
  data() {
    return {
    }
  },
  methods: {

  },
  created() {
  }
  
}
</script>

<style lang="stylus">
.banner-title
  width 70%
  position absolute
  left 17.6%
  top 145px
  height 180px
  h1
    // width 40%
    height 69%
    margin 0
    padding 0
    margin-top 40px
    background url('../assets/img/common/title-shangrao.png') no-repeat
    background-size auto 100%
    &.hengfeng
      background url('../assets/img/common/title-hengfeng.png') no-repeat
      background-size auto 100%


</style>